import { Component } from "@angular/core";
import { Store, Select } from "@ngxs/store";
import { GetFriends, GetFriendRequests, GetUser, GetFavorites, GetDiseases, GetPrivacy, GetNotifications } from "src/app/stores/app.action";
import { GetConversations } from "src/app/stores/chat.actions";
import { ChatStateService } from "src/app/stores/chat.state";
import { Observable } from "rxjs";
import { AppState } from "src/app/stores/app.state";
import { Notification } from "src/app/definition";
import { GetGroups, GetStream, GetUserGroups } from "src/app/stores/groups.actions";

@Component({
    selector: "app-tabs",
    templateUrl: "tabs.page.html",
})
export class TabsPage {
    @Select(ChatStateService.hasUnreadMessages) hasUnreadMessages$: Observable<boolean>;
    @Select(AppState.unreadNotifications) notifications$: Observable<Notification[]>;

    constructor(private store: Store) {
        this.store.dispatch([
            new GetUser(),
            new GetFriends(),
            new GetFriendRequests(),
            new GetFavorites(),
            new GetDiseases(),
            new GetPrivacy(),
            new GetConversations(),
            new GetNotifications(),
            new GetUserGroups(),
            new GetStream(),
            new GetGroups(),
            new GetUserGroups(),
        ]);
    }
}
